// extracted by mini-css-extract-plugin
export default {"mdc-card--app":"GenericForm_mdc-card--app__PJ2W7","flex-container":"GenericForm_flex-container__Tzc+s"};